import { useIntl } from "react-intl";
import { formatDateOnlyString } from "../../../../utils/dateUtils";
import "./styles.scss";

export interface IInfoProps {
  chassis: string;
  model: string;
  contractDuration: number;
  licensePlate: string;
  contractNumber: string;
  contractType: string;
  initialOdometer?: number;
  monthlyAverageKm?: number;
  initialHourMeter?: number;
  monthlyAverageHr?: number;
  accountName: string;
  contractStatus: string;
  createdAt?: string;
}

const Info = ({
  chassis,
  model,
  contractDuration,
  licensePlate,
  contractNumber,
  contractType,
  initialOdometer,
  monthlyAverageKm,
  initialHourMeter,
  monthlyAverageHr,
  accountName,
  contractStatus,
  createdAt,
}: IInfoProps) => {
  const intl = useIntl();

  return (
  <section className="margin-bottom-20 contract-details-info">
    <div className="contract-details-info__grid">
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.chassis" })}:</span>
        <span className="contract-details-info__value">{chassis}</span>
      </div>
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.contractStatus" })}:</span>
        <span className="contract-details-info__value">{contractStatus}</span>
      </div>
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.contractType" })}:</span>
        <span className="contract-details-info__value">{contractType}</span>
      </div>
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.contractNumber" })}:</span>
        <span className="contract-details-info__value">{contractNumber}</span>
      </div>
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.startAt" })}:</span>
        <span className="contract-details-info__value">{createdAt ? formatDateOnlyString(createdAt) : "—"}</span>
      </div>
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.model" })}:</span>
        <span className="contract-details-info__value">{model}</span>
      </div>
      
      {initialOdometer ? <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.odometer" })}:</span>
        <span className="contract-details-info__value">{`${initialOdometer.toLocaleString("pt-BR")} km`}</span>
      </div> : null}
      
      {initialHourMeter ? <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.hourmeter" })}:</span>
        <span className="contract-details-info__value">{`${initialHourMeter.toLocaleString("pt-BR")} h`}</span>
      </div> : null}

      <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.accountName" })}:</span>
        <span className="contract-details-info__value">{accountName}</span>
      </div>
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.licensePlate" })}:</span>
        <span className="contract-details-info__value">{licensePlate}</span>
      </div>
      
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.contractDuration" })}:</span>
        <span className="contract-details-info__value">{contractDuration} {contractDuration === 1 ? "mês" : "meses"}</span>
      </div>
      
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.monthlyAverage" })}:</span>
        <span className="contract-details-info__value">
          {monthlyAverageKm ? `${monthlyAverageKm.toLocaleString("pt-BR")} km` : null}
          {monthlyAverageHr ? `${monthlyAverageHr.toLocaleString("pt-BR")} h` : null}
        </span>
      </div>
      
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.totalCoverage" })}:</span>
        <span className="contract-details-info__value">
          {monthlyAverageKm ? `${(monthlyAverageKm * contractDuration).toLocaleString("pt-BR")} km` : null}
          {monthlyAverageHr ? `${(monthlyAverageHr * contractDuration).toLocaleString("pt-BR")} h` : null}
        </span>
      </div>
    </div>
  </section>
  );
};

export default Info;
